import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {TableFooter} from "@mui/material";
import Api from "../Api";
import Select from "react-select";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {amo, crm} from "../translate";
import AmoCall from "../components/AmoCall";
import {userCrmRequest} from "../store/actions/users";

const {REACT_APP_SERVER} = process.env;

let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'
const customStyles = {
    menu: (provided) => ({
        ...provided,
        position: 'absolute',
        zIndex: 9999,
        maxHeight: 300,
    }),
    menuPortal: (base) => ({...base, zIndex: 9999}), // Ensures portal menu is above modal
};
let newArr = []

function Amo(props) {
    const [amos, setAmo] = useState([])
    const [single, setSingle] = useState(0)
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.users.crmData)
    useEffect(() => {
        (async () => {
            await dispatch(userCrmRequest())
        })()
    }, [])
    const [sipNum, setSip] = useState([]);
    const handleOpen = useCallback((obj) => {
        if(obj.length){
            setSingle(obj)
        }
    },[])

    const handleSipSelect = useCallback((sip, id) => {

        setAmo(prev =>
            prev.map(u => {
                if (u.id === id) {
                    return {...u, sips: sip.map(s => ({sip:s.value,id:s.my_id}))};
                }
                return u;
            })
        );
    }, [])
    useEffect(() => {
        (async () => {
            const {data} = await Api.amoUsers();
            setAmo(data.data.users);
            newArr = data.data.users.map(u => ({userid: u.id, sip: u.sips || []}))
        })()
    }, [])
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.getAllowed()
                setSip(data.inputNumber?.sip)
            } catch (e) {
            }
        })()
    }, []);

    const handleSave = useCallback(async (item) => {
        try {
            let f = newArr.find((s) => s.userid === item.id)
            for (const fElement of f.sip) {
                await Api.amoCrmDelete(fElement.id)
            }
            let sips = []
            let single = null
            if (item.sips.length) {
                for (const fElement of item.sips) {
                    single = await Api.amoCrmCreate({userid:item.id,sip:fElement.sip, domain: userData?.amo?.domain})
                    sips.push(single.data.crm)
                }
            }
            const {data} = await Api.amoUsers();
            setAmo(data.data.users);
            newArr = newArr = data.data.users.map(u => ({userid: u.id, sip: u.sips || []}))

            if(sips.length){
                setSingle(sips)

            }

            if (f.sip.length && item.sips.length) {
                toast.success("Successfully edited")
            }else if(!f.sip.length){
                toast.success("Successfully created")
            }else if((f.sip.length && !item.sips.length)){
                toast.success("Successfully deleted")

            }
        } catch (e) {

        }
    }, [newArr, userData])
    return (
        <Wrapper>
            <div className="tableParent" id="tableParent">
                <Paper sx={{minWidth: 'fit-content', fontSize: 10}}>
                    <TableContainer
                    >
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow className="sip_header">
                                    <TableCell sx={{fontSize: 20,}} align="left" colSpan={9}>
                                        Users of AMO - {userData?.amo?.domain}
                                    </TableCell>
                                </TableRow>
                                <TableRow className="sip_num">
                                    <TableCell
                                        align='center'
                                    />
                                    <TableCell align='center'>
                                        ID
                                    </TableCell>
                                    <TableCell align='center'>
                                        Full name
                                    </TableCell>
                                    <TableCell align='center'>
                                        Email
                                    </TableCell>
                                    <TableCell
                                        align='center'
                                    >
                                        Type
                                    </TableCell>
                                    <TableCell
                                        align='center'
                                    >
                                        Selected SIP
                                    </TableCell>

                                    <TableCell
                                        align='center'
                                    >
                                        Action
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody id="dataBody">
                                {amos?.length ? amos?.map((s, _) => (
                                    <TableRow key={_} hover style={{cursor: 'pointer'}} role="checkbox" tabIndex={-1}>
                                        <TableCell align="center" onClick={() => handleOpen(s)}>
                                            {s?.rights?.is_active ? <CheckCircleIcon style={{color: color}}/> : null}
                                        </TableCell>
                                        <TableCell onClick={() => handleOpen(s.sips)} align="center">
                                            {s?.id}
                                        </TableCell>
                                        <TableCell onClick={() => handleOpen(s.sips)} align="center" >
                                            {s.name}
                                        </TableCell>
                                        <TableCell onClick={() => handleOpen(s.sips)} align="center" >
                                            {s.email}
                                        </TableCell>
                                        <TableCell align="center" onClick={() => handleOpen(s.sips)}>
                                            {s?.rights?.is_admin ? 'Admin' : ''}
                                        </TableCell>
                                        <TableCell align="center" style={{width: 300}}>
                                            <Select
                                                styles={customStyles}
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                isMulti
                                                onChange={(ev) => handleSipSelect(ev, s.id,)}
                                                menuPortalTarget={document.body}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                value={s.sips.map(k => ({value: +k.sip, label: +k.sip,my_id: k.id,}))}
                                                name="color"
                                                options={[{number: '', label: 'Select value'}, ...sipNum.map(k => (
                                                    {value: +k.number, label: `${k.number} ${k.context || ''}`}
                                                ))]}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <button className="addBtn" onClick={() => handleSave(s)}>
                                                Save
                                            </button>
                                        </TableCell>
                                    </TableRow>

                                )) : <TableRow hover role="checkbox" tabIndex={-1}>


                                    <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                        no data

                                    </TableCell>


                                </TableRow>
                                }

                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell align="center" colSpan={window.innerWidth < 400 ? 6 : 10}>
                                        <div style={{margin: 10}} className="crm_save_btn"/>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>


                </Paper>

            </div>
            <div className="tableParent">
                <Paper sx={{minWidth: 'fit-content', fontSize: 10,}}>
                    <div style={{padding:20}}>
                        <h4>{crm.config[+localStorage.getItem('atsLang') || 1]}</h4>
                        <ul className="crm_pluses">
                            <li>{amo.card[+localStorage.getItem('atsLang') || 1]}</li>
                            <li>{amo.record[+localStorage.getItem('atsLang') || 1]}</li>
                        </ul>
                    </div>
                </Paper>
            </div>
            {single?<AmoCall open={single} setOpen={setSingle}/>:null}
        </Wrapper>
    );
}

export default Amo;
// if (item.crm_id) {
//     // await Api.amoCrmEdit({...f, id: item.crm_id})
//     // const {data} = await Api.amoUsers();
//     // setAmo(data.data.users);
//     // newArr = data.data.users.map(u => ({userid: u.id, sip: u.sip || ''}))
// } else {
// await Api.amoCrmCreate({...f, domain: userData?.amo?.domain})
// const {data} = await Api.amoUsers();
// setAmo(data.data.users);
// newArr = data.data.users.map(u => ({userid: u.id, sip: u.sip || ''}))
// }